import { Injectable } from '@angular/core';
import { ISearchService } from './ISearchService';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WordSearchService implements ISearchService{
  nResults = 200;
  headsRequest: Observable<string[]>;

  constructor(private httpCient: HttpClient) {
    this.headsRequest = this.httpCient.get<string[]>(environment.backendUrl + 'static/heads.json') .pipe(shareReplay(1));
  }

  search(term: string): Observable<string[]> {
    return this.headsRequest.pipe(map(value => value.filter(word => word.startsWith(term)).slice(0, this.nResults)));
  }

  random(): Observable<string[]> {
    return this.headsRequest.pipe(map(value => {
      let results = [];
      for (let i = 0; i < 10; i++) {
        const index = Math.floor(Math.random() * value.length);
        results.push(value[index]);
      }
      return results;
    }));

  }
}
